export default __webpack_public_path__ + "static/media/i-lin.7f3db0a2.svg";